import { render, staticRenderFns } from "./NoRecipe.vue?vue&type=template&id=64e14fc6&"
import script from "./NoRecipe.vue?vue&type=script&lang=js&"
export * from "./NoRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports